module.exports = __webpack_public_path__ + "static/media/Tonikcover-01.99622f2b.png";